import { Typography } from "@mui/material";
import React from "react";
import { Title, Description } from "components/Typography";

const Library = () => {
  return (
    <div>
      <Title variant="h5">__LIBRARY.title</Title>
      <Description variant="subtitle1">__LIBRARY.subtitle</Description>
      <Typography variant="body2">__LIBRARY.data</Typography>
    </div>
  );
};

export default Library;
